module.exports = __webpack_public_path__ + "img/fb.1866e828.svg";